
const initState = () => ({
    openedMobileMenu: false
});


const state = () => ({...initState()});


import actions from './actions';
import getters from './getters';
import mutations from './mutations';

export const initialState = () => initState();

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
